import pino from "pino";
import { noticeError } from "../newrelic/requests";

const logLevel = process.env.LOG_LEVEL || "info";

const pinoLogger = pino({
  level: logLevel,
  formatters: {
    level(label) {
      return { level: label };
    },
  },
});

export const logger = (
  message: string,
  options?: { [key: string]: string },
) => {
  if (typeof window === "undefined") {
    // on the server log error to kibana
    pinoLogger.error(`${message} | ${JSON.stringify(options)}`);
  } else {
    // on client log error to new relic
    noticeError(message, options);
  }
};
